
































// @ is an alias to /src
import TopToolbar from "@/components/TopToolbar.vue";
import BottomNav from "@/components/BottomNav.vue";
import { Data, On, Route } from "@rocketbase/vue-extra-decorators";
import { Component, Vue } from "vue-property-decorator";

@Route({
  name: "History",
  path: "/history"
})
@Component({
  components: { TopToolbar, BottomNav }
})
export default class History extends Vue {
  @Data({
    default: [
      {
        text: "Wiederherstellen",
        align: "start",
        sortable: false,
        value: "active"
      },
      {
        text: "Datum",
        align: "start",
        sortable: false,
        value: "date"
      },
      {
        text: "Name",
        align: "start",
        sortable: false,
        value: "name",
        width: "20px"
      },
      {
        text: "Portionen",
        align: "start",
        sortable: false,
        value: "portions"
      },
      {
        text: "Schrank",
        align: "start",
        sortable: false,
        value: "locker.name"
      },
      {
        text: "Fach",
        align: "start",
        sortable: false,
        value: "subject"
      }
    ]
  })
  private headers!: [];

  @Data({ default: [] })
  private selected!: [];

  @On("hook:mounted")
  private async onMounted() {
    const { data } = await this.$store.dispatch("history");
  }

  private async revertIcon(item: { id: string }) {
    const { id } = item;
    const { status } = await this.$store.dispatch("revert", id);
    if (status === 200) this.$router.replace("/");
  }
}
